
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/tutorials/creating-a-smart-chain-on-a-single-node",
      function () {
        return require("private-next-pages/docs/smart-chains/tutorials/creating-a-smart-chain-on-a-single-node/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/tutorials/creating-a-smart-chain-on-a-single-node"])
      });
    }
  